export default {
  data() {
    return {
      isMobile: false,
    };
  },
  created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 992;
    },
    scrollToTop(el) {
      if (el && el.scrollTo) {
        el.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    scrollToBottom(el) {
      if (el && el.scrollTo) {
        el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
      }
    },
  },
}; 